var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4075 2.1001H13.1835V2.85681C13.1835 3.49217 12.6382 4.0133 11.9735 4.0133H10.8308C10.166 4.0133 9.6208 3.49217 9.6208 2.85681V2.1001H6.3793V2.85681C6.3793 3.49217 5.83407 4.0133 5.16934 4.0133H4.0266C3.36187 4.0133 2.81665 3.49217 2.81665 2.85681V2.1001H2.59258C1.59922 2.1001 0.800049 2.86395 0.800049 3.81341V12.9868C0.800049 13.9291 1.59922 14.7001 2.59258 14.7001H13.4075C14.3934 14.7001 15.2 13.9362 15.2 12.9868V3.81341C15.2 2.87109 14.4009 2.1001 13.4075 2.1001ZM13.9453 12.7512C13.9453 13.1296 13.6241 13.4365 13.2283 13.4365H2.80918C2.39092 13.4365 2.05482 13.1153 2.05482 12.7155V5.86939H13.9453V12.7512Z",
    fill: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.84699 2.99311H4.95301C5.14096 2.99311 5.3 2.84735 5.3 2.65995V0.633211C5.3 0.452748 5.14819 0.300049 4.95301 0.300049H3.84699C3.65904 0.300049 3.5 0.445807 3.5 0.633211V2.66689C3.5 2.84735 3.65181 3.00005 3.84699 3.00005V2.99311Z",
    fill: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0469 2.99311H12.153C12.3409 2.99311 12.5 2.84735 12.5 2.65995V0.633211C12.5 0.452748 12.3481 0.300049 12.153 0.300049H11.0469C10.859 0.300049 10.7 0.445807 10.7 0.633211V2.66689C10.7 2.84735 10.8518 3.00005 11.0469 3.00005V2.99311Z",
    fill: "#BEAEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.dcd70104625f63c19dfbf01dcd7531ab.svg";
export { ForwardRef as ReactComponent };